import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-cwestiwn-tabs',
    templateUrl: './cwestiwn-tabs.component.html',
    styleUrls: ['./cwestiwn-tabs.component.scss'],
    imports: [FormlyModule]
})
export class CwestiwnTabsComponent implements OnInit {

    @Input() public fields: FormlyFieldConfig[];
    @Input() public form: UntypedFormGroup;
    @Input() public model: any;
    @Input() public options: FormlyFormOptions;
    
  constructor() { }

  ngOnInit(): void {
  }
}